import { CasinoCategorySeoContext, CasinoGameSeoContext, CasinoPageSeoContext, SeoLocale } from "../../http/protocol";
import { SeoFallbackInputsByLocaleType, SeoFallbackInputsType } from "../seo/seoTypes";
import { seoByLocale } from "./seoDraftStore";

function byLocale(locales: SeoLocale[] | undefined, inputsFor: (code: string) => SeoFallbackInputsType): SeoFallbackInputsByLocaleType {
  const inputs: SeoFallbackInputsByLocaleType = {};
  (locales ?? []).forEach(({ code }) => {
    if (code !== undefined) {
      inputs[code] = inputsFor(code);
    }
  });
  return inputs;
}

/** What each of a tab's empty fields falls back to: the tab's CMS SEO, then the page's CMS SEO, then the defaults. */
export function tabFallbackInputs(context: CasinoPageSeoContext, tabKey: string): SeoFallbackInputsByLocaleType {
  const tabCms = seoByLocale(context.cms?.tabs?.[tabKey]);
  const pageCms = seoByLocale(context.cms?.pageEntries);
  return byLocale(context.locales, (code) => ({ tabCms: tabCms[code], pageCms: pageCms[code], defaults: context.defaults?.[code] }));
}

/** What each of a category's empty fields falls back to: the default casino page's CMS SEO, then the defaults. */
export function categoryFallbackInputs(context: CasinoCategorySeoContext): SeoFallbackInputsByLocaleType {
  const pageCms = seoByLocale(context.pageCms);
  return byLocale(context.locales, (code) => ({ pageCms: pageCms[code], defaults: context.defaults?.[code] }));
}

/** What each of a game's empty fields falls back to: the values derived from the game, OG image included. */
export function gameFallbackInputs(context: CasinoGameSeoContext): SeoFallbackInputsByLocaleType {
  return byLocale(context.locales, (code) => ({ game: context.defaults?.[code] }));
}
